import { forwardRef } from 'react';

import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { cn } from '@/utils';

const TooltipProvider = TooltipPrimitive.Provider;

const TooltipRoot = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipPortal = TooltipPrimitive.Portal;

const TooltipContent = forwardRef(
	({ className, sideOffset = 4, ...props }, ref) => (
		<TooltipPrimitive.Content
			ref={ref}
			sideOffset={sideOffset}
			className={cn(
				'z-[60] overflow-hidden rounded bg-black px-2 py-1.5 text-xs font-semibold text-white shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
				className
			)}
			{...props}
		/>
	)
);
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

function Tooltip({
	children,
	title,
	tooltipContentProps,
	side,
	sideOffset,
	delayDuration,
	disabled,
	disableHoverableContent,
	container,
	...props
}) {
	if (disabled || !title) {
		return children;
	}

	return (
		<TooltipProvider
			disableHoverableContent={disableHoverableContent}
			delayDuration={100}
		>
			<TooltipRoot {...props}>
				<TooltipTrigger asChild>{children}</TooltipTrigger>
				<TooltipPortal container={container}>
					<TooltipContent
						side={side}
						sideOffset={sideOffset}
						{...tooltipContentProps}
					>
						{title && <p>{title}</p>}
					</TooltipContent>
				</TooltipPortal>
			</TooltipRoot>
		</TooltipProvider>
	);
}

export {
	Tooltip,
	TooltipRoot,
	TooltipTrigger,
	TooltipContent,
	TooltipProvider,
	TooltipPortal
};

export default Tooltip;
